const ConditionalComponent = ({ condition, children, elseCondition = null }) =>
	condition ? children : elseCondition

export default ConditionalComponent
